const stripeMixin = {
  methods: {
    getStripeUrl: function (relativeUrl) {
      return process.env.VUE_APP_STRIPE_BACKEND_URL + relativeUrl.toString()
    },
    getStripePublicKeyUrl: function () {
      return this.getStripeUrl('/keys/public/')
    },
    getStripeMinMaxAmountsUrl: function () {
      return this.getStripeUrl('/amounts/')
    },
    getStripeCheckUrl: function () {
      return this.getStripeUrl('/check/')
    },
    getStripeWebHookUrl: function () {
      return this.getStripeUrl('/success/')
    }
  }
}

export default stripeMixin
